import React from 'react'
import { Select, Input ,Upload, message, Button } from 'antd';

const { Option } = Select;
const { TextArea } = Input;
function handleChange(value) {
  console.log(`selected ${value}`);
}
const props = {
  name: 'file',
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  headers: {
    authorization: 'authorization-text',
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

function Documents() {
	
  return (
  <>
    <div className='container'>
	<label class='subtext-2'>Identification type</label>
		<Select defaultValue="select" style={{ width: '100%',height: 50, border: '1px solid #333333', borderRadius: 10, display:'flex', alignItems:'center' }}  bordered={false}onChange={handleChange}>
      <Option value="select">Choose an identification type</Option>
      <Option value="employed">Employed</Option>
      <Option value="unemployed">Unemployed</Option>
	  <Option value="selfemployed">Self Employed</Option>
    </Select>
	
	<br />
    <label class='subtext-2'>ID number</label>
	<Input placeholder="Enter an ID number" style={{ width: '100%', height: 50, border: '1px solid #333333', borderRadius: 10 }} bordered={false} />
	
	<br /><br />
	
	<label class='subtext-2'>Upload ID</label> <br/>
	<div id='upload-id' style={{ width: '100%',height: 133, border: '1px solid #333333', borderRadius: 10, display:'flex', alignItems:'center', justifyContent: 'center' }}>
		<Upload {...props}>
		
	<center><img class='upload-id' src='./images/upload-id.png'/><br/></center>
	<label class='subtext-3' id='upload-id' >Click here to browse files</label>
	
	
  </Upload>
  </div>
	
	<br />
	<label class='subtext-2'>Upload picture</label>
	<div id='upload-id' style={{ width: '100%',height: 133, border: '1px solid #333333', borderRadius: 10, display:'flex', alignItems:'center', justifyContent: 'center' }}>
		<Upload {...props}>
		
	<center><img class='upload-pic' src='./images/upload-pic.png'/><br/></center>
	<p class='subtext-3' id='upload-id' >Take  a picture</p>
	
	
	</Upload>
	</div>
    </div>
	
	</>
  )
}

export default Documents